Controller = App.loadClass 'core::Angular/Controller'

class exports.DashboardController extends Controller
    constructor: (@scope, @state, @http, @session, @router, @window) ->
        @settingDefault = false
        @hasDefault = false
        @experiences = []
        @show = false
        @carouselOptions = {
            pixelsPerClick: 245
        }

        @scope.$on 'dashboard:closed', () =>
            @settingDefault = false

        @http.get 'backend/dashboard/user-experiences'
        .then (experiences) =>
            @scope.$parent.drop?.show = experiences.data.length > 1
            @experiences = experiences.data
            .sort (experienceA, experienceB) ->
                return experienceA.text.localeCompare experienceB.text
            .sort (experienceA, experienceB) ->
                return experienceA.company.localeCompare experienceB.company
            @hasDefault = not not (experience for experience in @experiences when experience.default).length
            @show = true

            if @state.includes('grower')
                state = 'grower'
            else if @state.includes('portal')
                state = 'portal'

            if state
                company = @session.get "SelectedCompany-#{state}"

                if not company
                    # console.log "in state #{state} but no experience cookie"
                    @router.determineDestination({ r: state })
                    return

                if _.filter(@experiences, { state: state, company: company }).length is 0
                    # console.log "in state #{state} but no experience for company #{company}"
                    @router.determineDestination({ r: state })
                    return

    setDefault: () ->
        @settingDefault = not @settingDefault

    setDefaultTo: (experience) ->
        @http.post 'backend/dashboard/set-default', experience
        .then () =>
            @settingDefault = false
            @hasDefault = experience?
            for exp in @experiences
                exp.default = exp is experience

    experienceClicked: (experience) ->
        if @settingDefault
            @setDefaultTo experience
        else
            @session.set "SelectedCompany-#{experience.state}", experience.company

            currentApp = @state.$current.name.split('.')[0]

            # https://www.pivotaltracker.com/story/show/153074469
            # https://www.pivotaltracker.com/story/show/153088019
            # Uncommenting this block would fix the problem in the first story,
            # but it causes the problem in the second
            # if experience.state is currentApp
            #     @scope.$emit 'dashboard:close'
            #     return

            if experience.state is currentApp or currentApp is 'dashboard'
                @state.go experience.state, {}, { reload: true }
            else
                @scope.$emit 'dashboard:close'

                # Hardcode an exception for touchpoint, because it's the only state with a url
                # that's different from the state name.
                url = experience.state

                if @userId is 814
                    @state.go experience.state, {}, { reload: true }
                else
                    @window.open "#{@window.location.origin}/#{url}"
            return
